export const BODY_ID = 'RegistrationCardEditPersonalId';
